import React from 'react';
import PropTypes from 'prop-types';

import env from 'lib/env';

/* @typedef Coordinates
 * @property {number} lat
 *                    Latitude.
 * @property {number} lon
 *                    Longitude.
 */
const coordinatesPropType = PropTypes.shape({
  lat: PropTypes.number,
  lng: PropTypes.number,
});

const propTypes = {
  className: PropTypes.string,
  destination: coordinatesPropType,
  location: coordinatesPropType,
  mapSize: PropTypes.string,
};

const defaultProps = {
  className: null,
  destination: null,
  location: null,
  mapSize: '740x460',
};

export const LOCATION_PIN = encodeURIComponent('https://dbmgns9xjyk0b.cloudfront.net/map-icons/location-pin.png');
export const DESTINATION_PIN = encodeURIComponent('https://dbmgns9xjyk0b.cloudfront.net/map-icons/destination-pin.png');

const { GOOGLE_MAPS_API_KEY, GOOGLE_STATIC_MAPS_ID } = env();

/**
 * @param {Coordinates} [location]
 *                      Location.
 * @param {Coordinates} [destination]
 *                      Destination.
 * @param {string} mapSize
 *                 String specifying map size. Example: '740x460'.
 *
 * @returns {String}
 *          URL to retrieve static image of a Google Map.
 */
export function generateStaticMapUrl(location, destination, mapSize) {
  let url = `https://maps.googleapis.com/maps/api/staticmap?size=${mapSize}&key=${GOOGLE_MAPS_API_KEY}`;

  if (GOOGLE_STATIC_MAPS_ID) {
    url += `&map_id=${GOOGLE_STATIC_MAPS_ID}`;
  }

  if (destination) {
    url += `&markers=icon:${DESTINATION_PIN}%7C${destination.lat},${destination.lng}`;
  }

  if (location) {
    url += `&markers=icon:${LOCATION_PIN}%7C${location.lat},${location.lng}`;
  }

  return url;
}

const MiniMap = ({ className, destination, location, mapSize }) => {
  const url = generateStaticMapUrl(location, destination, mapSize);

  return (
    <div className={className}>
      <img src={url} alt="Map" />
    </div>
  );
};

MiniMap.propTypes = propTypes;
MiniMap.defaultProps = defaultProps;
export default MiniMap;
